import { StyleSheet } from 'aphrodite';
import { TSS_DARK_BLUE } from './colors';

var styles = StyleSheet.create({
  H1: {
    fontSize: '2.4rem',
    color: TSS_DARK_BLUE,
    fontWeight: 600
  },

  H2: {
    fontSize: '2.0rem',
    color: TSS_DARK_BLUE,
    fontWeight: 600
  },

  H3: {
    fontSize: '1.8rem',
    color: TSS_DARK_BLUE,
    fontWeight: 600
  },

  H4: {
    fontSize: '1.6rem',
    color: TSS_DARK_BLUE,
    fontWeight: 600
  },

  STANDARD_TEXT: {
    fontSize: '1.4rem'
  }
});

export var H1 = styles.H1;
export var H2 = styles.H2;
export var H3 = styles.H3;
export var H4 = styles.H4;
export var STANDARD_TEXT = styles.STANDARD_TEXT;